import { render, staticRenderFns } from "./InfoReplyManagement.vue?vue&type=template&id=242e7159&scoped=true"
import script from "./InfoReplyManagement.vue?vue&type=script&lang=js"
export * from "./InfoReplyManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e7159",
  null
  
)

export default component.exports